import { useMemo } from "react";

import {
  SETTINGS_NAV_SECTIONS,
  type SettingsNavSectionId,
  type SidebarNavChildItem,
} from "@/config/sidebar-nav";
import { useSidebarNavFeature } from "@/hooks/use-sidebar-nav-features";

export type SettingsNavSection = {
  id: SettingsNavSectionId;
  items: SidebarNavChildItem[];
};

/**
 * The visible Settings pages for the current member, grouped into the
 * config's sections. Single source of truth is `sidebarNavFeatures` so the
 * command palette, the mobile More list and this nav never disagree.
 */
export function useSettingsNavSections(): SettingsNavSection[] {
  const settings = useSidebarNavFeature("settings");

  return useMemo(() => {
    const children = settings?.children ?? [];
    return SETTINGS_NAV_SECTIONS.map((id) => ({
      id,
      items: children.filter((c) => c.section === id),
    })).filter((s) => s.items.length > 0);
  }, [settings]);
}
